import {useState} from 'react';

export default function ResetPasswordScreen() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token') || '';
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (password !== confirm) {
            setError('Passwords do not match.');
            return;
        }
        try {
            const res = await fetch('/auth/reset-password', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({token, password}),
            });
            if (!res.ok) {
                const data = await res.json();
                setError(data.error || 'Reset failed. Please try again.');
                return;
            }
            window.location.href = '/?signin&reset=success';
        } catch {
            setError('Reset failed. Please try again.');
        }
    }

    return (
        <div className="login-screen">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Reset password</h2>
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="password"
                    placeholder="New password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Confirm new password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!password || !confirm}
                >Set new password</button>
                <p className="login-register-link">
                    <a href="/?signin">Back to sign in</a>
                </p>
            </form>
        </div>
    );
}
